module.exports = __webpack_public_path__ + "img/Frame 1104one1.678a6fd8.png";